import store from '@/store'
import i18n from '@/libs/i18n'
import { silentRoles } from '@/views/users/base'
import { getTenantContextInstance as tenantCtx } from '@/plugins'

export const FEATURES = {
  ADMIN_PANEL_MULTILANGUAGE: 'ADMIN_PANEL_MULTILANGUAGE',
  FORM_CONFIGURATIONS_QUOTA: 'FORM_CONFIGURATIONS_QUOTA',
  PREFERENCE_CENTERS_QUOTA: 'PREFERENCE_CENTERS_QUOTA',
  USERS_QUOTA: 'USERS_QUOTA',
  PAGES_QUOTA: 'PAGES_QUOTA',
  FORMS_QUOTA: 'FORMS_QUOTA',
  TAGS_QUOTA: 'TAGS_QUOTA',
  FORM_FIELDS_QUOTA: 'FORM_FIELDS_QUOTA',
  CLIENT_ADMIN_API_QUOTA: 'CLIENT_ADMIN_API_QUOTA',
  COUNTERS_QUOTA: 'COUNTERS_QUOTA',
  WEBHOOKS_QUOTA: 'WEBHOOKS_QUOTA',
  REGULAR_EXPRESSIONS_QUOTA: 'REGULAR_EXPRESSIONS_QUOTA',
  THEMES_QUOTA: 'THEMES_QUOTA',
  ELEMENTS_QUOTA: 'ELEMENTS_QUOTA',
  STORAGE_QUOTA: 'STORAGE_QUOTA',
  INTEGRATIONS_GTM_INTEGRATION: 'INTEGRATIONS_GTM',
  INTEGRATIONS_VWO_INTEGRATION: 'INTEGRATIONS_VWO',
  INTEGRATIONS_POSTCODE_API_INTEGRATION: 'INTEGRATIONS_POSTCODE_API_INTEGRATION',
  INTEGRATIONS_RECAPTCHA_INTEGRATION: 'INTEGRATIONS_RECAPTCHA',
  INTEGRATIONS_GOOGLE_DRIVE_INTEGRATION: 'INTEGRATIONS_GOOGLE_DRIVE',
  INTEGRATIONS_ONEDRIVE_INTEGRATION: 'INTEGRATIONS_ONEDRIVE',
  ADMIN_PANEL_THEME_CUSTOMIZER: 'ADMIN_PANEL_THEME_CUSTOMIZER',
  DASHBOARD_REALTIME_LATEST_TRANSACTIONS_VIEW: 'DASHBOARD_REALTIME_LATEST_TRANSACTIONS_VIEW',
  DASHBOARD_MONTHLY_PAYMENTS_CHART: 'DASHBOARD_MONTHLY_PAYMENTS_CHART',
  DASHBOARD_MONTHLY_SUBSCRIBERS_CHART: 'DASHBOARD_MONTHLY_SUBSCRIBERS_CHART',
  DASHBOARD_LATEST_REVISIONS_VIEW: 'DASHBOARD_LATEST_REVISIONS_VIEW',
  PAGES_REVISIONS: 'PAGES_REVISIONS',
  PAGES_GRID_VIEW: 'PAGES_GRID_VIEW',
  /** Page-builder variable chips and conditional blocks. */
  PAGES_PERSONALIZATION: 'PAGES_PERSONALIZATION',
  /** Canvas notices for images without alt text, plus a decorative-image option. */
  PAGES_IMAGE_ALT_NOTICES: 'PAGES_IMAGE_ALT_NOTICES',
  /** Page, form, and preference-center translations. */
  TRANSLATIONS_MODULE: 'TRANSLATIONS_MODULE',
  /** AI batch translate on the page translations module. */
  AI_TRANSLATIONS: 'AI_TRANSLATIONS',
  FORMS_REVISIONS: 'FORMS_REVISIONS',
  FORM_CONFIGURATIONS_MAPPING_DASHBOARD: 'FORM_CONFIGURATIONS_MAPPING_DASHBOARD',
  FORM_CONFIGURATIONS_REVISIONS: 'FORM_CONFIGURATIONS_REVISIONS',
  PREFERENCE_CENTERS_REVISIONS: 'PREFERENCE_CENTERS_REVISIONS',
  /** Prefill-based show/hide rules on preference-center subscriptions. */
  PREFERENCE_CENTERS_CAMPAIGN_DISPLAY_CONDITIONS: 'PREFERENCE_CENTERS_CAMPAIGN_DISPLAY_CONDITIONS',
  FORMS_TRANSLATIONS: 'FORMS_TRANSLATIONS',
  INTEGRATIONS_CUSTOM_INTEGRATIONS_QUOTA: 'INTEGRATIONS_CUSTOM_INTEGRATIONS_QUOTA',
  INTEGRATIONS_MAPPING_OBJECTS: 'INTEGRATIONS_MAPPING_OBJECTS',
  FORMS_EMBEDDING: 'FORMS_EMBEDDING',
  TRANSACTIONS_CONNECTOR_RETRY: 'TRANSACTIONS_CONNECTOR_RETRY',
  TRANSACTIONS_SEARCH_INDEX: 'TRANSACTIONS_SEARCH_INDEX',
  /** Per-connector status under each transaction id. */
  TRANSACTIONS_CONNECTOR_STATUSES: 'TRANSACTIONS_CONNECTOR_STATUSES',
  FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING: 'FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING',
  FORM_CONFIGURATIONS_FIELD_LEVEL_CONDITIONS: 'FORM_CONFIGURATIONS_FIELD_LEVEL_CONDITIONS',
  FORM_CONFIGURATIONS_OBJECT_LEVEL_CONDITIONS: 'FORM_CONFIGURATIONS_OBJECT_LEVEL_CONDITIONS',
  FORM_CONFIGURATIONS_CONDITIONAL_STATIC_VALUE: 'FORM_CONFIGURATIONS_CONDITIONAL_STATIC_VALUE',
  FORM_CONFIGURATIONS_MAPPING_JSON_ENCODE: 'FORM_CONFIGURATIONS_MAPPING_JSON_ENCODE',
  FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS: 'FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS',
  /** Warn when a Novti field has different validation rules across connectors. */
  FORM_CONFIGURATIONS_VALIDATION_DRIFT: 'FORM_CONFIGURATIONS_VALIDATION_DRIFT',
  PREFILL_TOKEN_BLOCK_LIST: 'PREFILL_TOKEN_BLOCK_LIST',
  /** When enabled, Salesforce authorization-code login uses PKCE (S256) via Cloud Functions. */
  SALESFORCE_OAUTH_PKCE: 'SALESFORCE_OAUTH_PKCE',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_SALESFORCE_INTEGRATION: 'FORM_CONFIGURATIONS_SALESFORCE_INTEGRATION',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_FINDOCK_V1_INTEGRATION: 'FORM_CONFIGURATIONS_FINDOCK_V1_INTEGRATION',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_MARKETING_CLOUD_INTEGRATION: 'FORM_CONFIGURATIONS_MARKETING_CLOUD_INTEGRATION',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_FINDOCK_V2_INTEGRATION: 'FORM_CONFIGURATIONS_FINDOCK_V2_INTEGRATION',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_CONVERSE_INTEGRATION: 'FORM_CONFIGURATIONS_CONVERSE_INTEGRATION',
  // NOT YET IMPLEMENTED
  FORM_CONFIGURATIONS_CUSTOM_CONNECTORS_INTEGRATION: 'FORM_CONFIGURATIONS_CUSTOM_CONNECTORS_INTEGRATION',
  // NOT YET IMPLEMENTED
  SUBDOMAIN_MAPPINGS: 'SUBDOMAIN_MAPPINGS',
  // NOT YET IMPLEMENTED
  USAGE_DASHBOARD: 'USAGE_DASHBOARD',
  // NOT YET IMPLEMENTED
  BILLING_STRIPE_CUSTOMER_PORTAL: 'BILLING_STRIPE_CUSTOMER_PORTAL',
  // NOT YET IMPLEMENTED
  FORMS_PRODUCTS_COMPONENT: 'FORMS_PRODUCTS_COMPONENT',
  // NOT YET IMPLEMENTED
  FORMS_GIVING_EXAMPLE_COMPONENT: 'FORMS_GIVING_EXAMPLE_COMPONENT',
  // NOT YET IMPLEMENTED
  FORMS_CONDITIONAL_OPTIONS: 'FORMS_CONDITIONAL_OPTIONS',
  // NOT YET IMPLEMENTED
  FORMS_SURVEY_COMPONENT: 'FORMS_SURVEY_COMPONENT',
  // NOT YET IMPLEMENTED
  FORMS_ADDRESS_COMPONENT: 'FORMS_ADDRESS_COMPONENT',
  // NOT YET IMPLEMENTED
  FORMS_POSTCODE_API_COMPONENT: 'FORMS_POSTCODE_API_COMPONENT',
  // NOT YET IMPLEMENTED
  FORMS_RECAPTCHA_COMPONENT: 'FORMS_RECAPTCHA_COMPONENT',
  // NOT YET IMPLEMENTED
  ROOT_DOMAIN_MAPPINGS: 'ROOT_DOMAIN_MAPPINGS',
}

/**
 * Tenant-document runtime feature flags (`admin/{tenantId}.featureFlags`).
 * These gate functionality per tenant and are distinct from Stripe package
 * entitlements checked via `allowed()` (e.g. `*_QUOTA`).
 */
export const TENANT_FEATURE_FLAGS = {
  FORMS_EMBEDDING: FEATURES.FORMS_EMBEDDING,
  TRANSACTIONS_CONNECTOR_RETRY: FEATURES.TRANSACTIONS_CONNECTOR_RETRY,
  TRANSACTIONS_SEARCH_INDEX: FEATURES.TRANSACTIONS_SEARCH_INDEX,
  FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING: FEATURES.FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING,
  FORM_CONFIGURATIONS_FIELD_LEVEL_CONDITIONS: FEATURES.FORM_CONFIGURATIONS_FIELD_LEVEL_CONDITIONS,
  FORM_CONFIGURATIONS_OBJECT_LEVEL_CONDITIONS: FEATURES.FORM_CONFIGURATIONS_OBJECT_LEVEL_CONDITIONS,
  FORM_CONFIGURATIONS_CONDITIONAL_STATIC_VALUE: FEATURES.FORM_CONFIGURATIONS_CONDITIONAL_STATIC_VALUE,
  FORM_CONFIGURATIONS_MAPPING_JSON_ENCODE: FEATURES.FORM_CONFIGURATIONS_MAPPING_JSON_ENCODE,
  FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS: FEATURES.FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS,
  INTEGRATIONS_MAPPING_OBJECTS: FEATURES.INTEGRATIONS_MAPPING_OBJECTS,
  PREFILL_TOKEN_BLOCK_LIST: FEATURES.PREFILL_TOKEN_BLOCK_LIST,
  PAGES_GRID_VIEW: FEATURES.PAGES_GRID_VIEW,
  PAGES_PERSONALIZATION: FEATURES.PAGES_PERSONALIZATION,
  PAGES_IMAGE_ALT_NOTICES: FEATURES.PAGES_IMAGE_ALT_NOTICES,
  TRANSLATIONS_MODULE: FEATURES.TRANSLATIONS_MODULE,
  AI_TRANSLATIONS: FEATURES.AI_TRANSLATIONS,
  FORM_CONFIGURATIONS_VALIDATION_DRIFT: FEATURES.FORM_CONFIGURATIONS_VALIDATION_DRIFT,
  TRANSACTIONS_CONNECTOR_STATUSES: FEATURES.TRANSACTIONS_CONNECTOR_STATUSES,
  SALESFORCE_OAUTH_PKCE: FEATURES.SALESFORCE_OAUTH_PKCE,
  PREFERENCE_CENTERS_CAMPAIGN_DISPLAY_CONDITIONS: FEATURES.PREFERENCE_CENTERS_CAMPAIGN_DISPLAY_CONDITIONS,
}

/**
 * String-valued tenant feature flag for page builder storage backend.
 * Stored on `admin/{tenantId}.featureFlags.PAGE_STORAGE_BACKEND`.
 */
export const PAGE_STORAGE_BACKEND = 'PAGE_STORAGE_BACKEND'

export const PAGE_STORAGE_BACKEND_OPTIONS = [
  'firestore',
  'google-cloud-storage',
]

/**
 * String-valued tenant feature flag for the Vertex model used by Translate with AI.
 * Stored on `admin/{tenantId}.featureFlags.AI_TRANSLATIONS_MODEL`.
 */
export const AI_TRANSLATIONS_MODEL = 'AI_TRANSLATIONS_MODEL'

export const AI_TRANSLATIONS_MODEL_DEFAULT = 'gemini-3.8-flash'

/**
 * The models a tenant may pick for Translate with AI.
 *
 * Only models Google serves on the `eu` multi-region are listed, because that
 * is the only location the callable uses, and ones close to their retirement
 * date are left out so a tenant is not set up to fail. Model availability was
 * read from each model's Supported regions table; the date in the comment is
 * its listed retirement date.
 *
 * Not listed: `gemini-3.6-flash` (retires November 19, 2026), `gemini-3.7-flash`
 * (January 28, 2027), and the `gemini-2.5` models, which Google does not serve
 * on the `eu` multi-region at all.
 */
export const AI_TRANSLATIONS_MODEL_OPTIONS = [
  AI_TRANSLATIONS_MODEL_DEFAULT, // September 2, 2027 or later
  'gemini-4-argon', // October 13, 2027 or later
  'gemini-3.5-flash', // May 19, 2027 or later
  'gemini-3.5-flash-lite', // July 21, 2027 or later
]

/**
 * Resolves the configured Vertex model for Translate with AI.
 *
 * A stored value that is not one of the offered models is ignored rather than
 * passed through: it could be a model the tenant's location does not serve, or
 * one that has since been retired, and both would fail on every request.
 *
 * @param {Object} [featureFlags]
 *
 * @returns {string}
 */
export const resolveAiTranslationsModel = (featureFlags = {}) => {
  const configured = typeof featureFlags?.[AI_TRANSLATIONS_MODEL] === 'string'
    ? featureFlags[AI_TRANSLATIONS_MODEL].trim()
    : ''

  return AI_TRANSLATIONS_MODEL_OPTIONS.includes(configured)
    ? configured
    : AI_TRANSLATIONS_MODEL_DEFAULT
}

/**
 * Verifies if the requested action will not result in exceeding the limits set by the active subscription for the tenant.
 *
 * @param {string} quota the limit value set by the package in the tenant's subscription
 * @param {number} total the current amount of the resource
 *
 * @returns {boolean}
 */
const isQuotaReached = (quota, total) => (total >= parseFloat(quota))

/**
 * This is the main function that holds the logic for the subscription package-level feature toggle based restrictions.
 * With one of the featureKeys defined in the FEATURES variable you can verify if the tenant is allowed to perform the action(s) that are associated with the feature key.
 *
 * @param {string} featureKey the key name of the feature toggle
 *
 * @returns {boolean}
 */
export const allowed = featureKey => {
  const { packageFeatures } = tenantCtx()

  switch (featureKey) {
    case FEATURES.PAGES_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['pages/getAll'].length,
      )
    case FEATURES.FORMS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['forms/getAll'].length,
      )
    case FEATURES.TAGS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['tags/getAll'].length,
      )
    case FEATURES.FORM_FIELDS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['formFields/getAll'].length,
      )
    case FEATURES.REGULAR_EXPRESSIONS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['regularExpressions/getAll'].length,
      )
    case FEATURES.FORM_CONFIGURATIONS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['formConfigurations/getAll'].length,
      )
    case FEATURES.PREFERENCE_CENTERS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['preferenceCenters/getAll'].length,
      )
    case FEATURES.USERS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['users/getAll'].filter(
          user => !silentRoles.includes(user.role),
        ).length,
      )
    case FEATURES.COUNTERS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['counters/getAll'].length,
      )
    case FEATURES.THEMES_QUOTA:
      if (packageFeatures[featureKey] === undefined) {
        console.debug(i18n.t('Feature key for Themes quota not found.'))

        return false
      }

      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['themes/getTenantThemes'].length,
      )
    case FEATURES.ELEMENTS_QUOTA:
      if (packageFeatures[featureKey] === undefined) {
        console.debug(i18n.t('Feature key for Elements quota not found.'))

        return false
      }

      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['elements/getElements'].length,
      )
    case FEATURES.INTEGRATIONS_CUSTOM_INTEGRATIONS_QUOTA:
      return !isQuotaReached(
        packageFeatures[featureKey],
        store.getters['integrations/getCustomIntegrations'].length,
      )
    default:
      return JSON.parse(packageFeatures[featureKey] || 'false')
  }
}

/** Support flag on admin/_shared/connectors documents (connectors.supports array). */
export const CONNECTOR_SUPPORT_MULTI_OBJECT_MAPPINGS = 'multiObjectMappings'

/**
 * Checks whether a specific connector supports multi-object / loopable mapping.
 * Both conditions must be true:
 * 1. The tenant's featureFlags document (admin > $tenant > featureFlags) has FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING set to true
 * 2. The connector's supports array includes multiObjectMappings (from admin/_shared/connectors;
 *    custom-integration:* connectors inherit from the shared custom-integration definition)
 *
 * @param {string} connectorKey the connector identifier (e.g. 'salesforce', 'custom-integration:boomi')
 *
 * @returns {boolean}
 */
export const supportsMultiObjectMapping = connectorKey => {
  if (!connectorKey) {return false}

  const featureFlags = store.getters['tenant/getFeatureFlags'] || {}

  if (!featureFlags[FEATURES.FORM_CONFIGURATIONS_MULTI_OBJECT_MAPPING]) {return false}

  const connector = store.getters['connectors/getByKey']?.(connectorKey)

  return Boolean(connector?.supports?.includes(CONNECTOR_SUPPORT_MULTI_OBJECT_MAPPINGS))
}

/**
 * Checks whether related-object lookups are available on a Prefill dashboard.
 * Both conditions must be true:
 * 1. The tenant's featureFlags document has FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS set to true
 * 2. The selected prefill connector is Salesforce (not Marketing Cloud or a custom integration)
 *
 * @param {string} connectorKey the prefill connector identifier (e.g. 'salesforce')
 *
 * @returns {boolean}
 */
export const supportsSalesforcePrefillRelatedObjects = connectorKey => {
  if (connectorKey !== 'salesforce') {return false}

  const featureFlags = store.getters['tenant/getFeatureFlags'] || {}

  return !!featureFlags[FEATURES.FORM_CONFIGURATIONS_SALESFORCE_PREFILL_RELATED_OBJECTS]
}

/**
 * Whether this tenant uses PKCE for Salesforce authorization-code login.
 * Off by default so existing Connected Apps keep the legacy browser exchange
 * until the flag is enabled under Organization → Feature flags.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isSalesforceOauthPkceEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.SALESFORCE_OAUTH_PKCE]
)

/**
 * Whether the page builder shows personalization blocks and variable insertion.
 * Off by default. Enable it under Organization → Feature flags.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isPagesPersonalizationEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.PAGES_PERSONALIZATION]
)

/**
 * Whether the page builder marks images that miss alternative text and offers
 * a "decorative" option. Off by default. Enable under Organization → Feature flags.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isPagesImageAltNoticesEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.PAGES_IMAGE_ALT_NOTICES]
)

/**
 * Whether page, form, and preference-center translations are available.
 * Off by default. Enable under Organization → Feature flags.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isTranslationsModuleEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.TRANSLATIONS_MODULE]
)

/**
 * Whether AI batch translate is available on the page translations module.
 * Off by default. Enable under Organization → Feature flags. Requires
 * `TRANSLATIONS_MODULE` as well for the button to show.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isAiTranslationsEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.AI_TRANSLATIONS]
)

/**
 * Whether preference-center subscriptions can be shown or hidden from Prefill fields.
 * Off by default. Enable under Organization → Feature flags. The public renderer
 * still evaluates a stored condition set when this flag is off.
 *
 * @param {Object} [featureFlags] Optional flags map (defaults to the tenant store)
 *
 * @returns {boolean}
 */
export const isPreferenceCentersCampaignDisplayConditionsEnabled = (featureFlags = store.getters['tenant/getFeatureFlags']) => (
  !!featureFlags?.[FEATURES.PREFERENCE_CENTERS_CAMPAIGN_DISPLAY_CONDITIONS]
)
